// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import ScannerModal from '../components/ScannerModal';

// const HospitalDashboard = () => {
//     const navigate = useNavigate();
//     const [hospitalData, setHospitalData] = useState(null);
//     const [showScanner, setShowScanner] = useState(false);

//     // --- FAKE DATA FOR UI (Replace with API calls later) ---
//     const stats = [
//         { title: "Total Doctors", value: "127", change: "+12% from last month", color: "text-success", icon: "bi-people-fill" },
//         { title: "Today's Appointments", value: "242", change: "+8% from yesterday", color: "text-primary", icon: "bi-calendar-check" },
//         { title: "Active Patients", value: "3,847", change: "+15% from last month", color: "text-info", icon: "bi-person-heart" },
//         { title: "Avg. Wait Time", value: "18 min", change: "-5% improvement", color: "text-warning", icon: "bi-stopwatch" }
//     ];

//     const doctorsList = [
//         { name: "Dr. Michael Chen", specialty: "Cardiology", status: "Active", bookings: 12 },
//         { name: "Dr. Sarah Jones", specialty: "Pediatrics", status: "Active", bookings: 8 },
//         { name: "Dr. Emily Foster", specialty: "Dermatology", status: "Active", bookings: 15 },
//         { name: "Dr. Rachel Martinez", specialty: "Neurology", status: "Inactive", bookings: 0 },
//         { name: "Dr. David Kim", specialty: "Orthopedics", status: "Active", bookings: 10 },
//     ];

//     useEffect(() => {
//         // 1. Auth Check
//         const user = JSON.parse(localStorage.getItem('DDoctorUser'));
//         if (!user || user.role !== 'hospital') {
//             alert("Access Denied.");
//             navigate('/');
//             return;
//         }
//         setHospitalData(user);
//     }, [navigate]);

//     return (
//         <div className="container-fluid bg-light min-vh-100 p-4">

//             {/* --- HEADER SECTION --- */}
//             <div className="d-flex justify-content-between align-items-center mb-5">
//                 <div>
//                     <h2 className="fw-bold text-dark mb-1">
//                         {hospitalData?.name || "Hospital"} Network
//                     </h2>
//                     <p className="text-muted mb-0">Administration Portal & Real-time metrics</p>
//                 </div>

//                 {/* PRIMARY ACTION BUTTON (The "Scan QR" Functionality) */}
//                 <button
//                     className="btn btn-primary btn-lg fw-bold shadow-sm d-flex align-items-center gap-2"
//                     style={{ backgroundColor: '#0d6efd', borderRadius: '8px' }}
//                     onClick={() => setShowScanner(true)} // <--- Open Modal
//                 >
//                     <i className="bi bi-qr-code-scan"></i> Scan Patient Card
//                 </button>
//             </div>

//             {/* --- 1. STATS CARDS ROW --- */}
//             <div className="row g-4 mb-5">
//                 {stats.map((stat, index) => (
//                     <div className="col-md-3" key={index}>
//                         <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
//                             <div className="card-body p-4">
//                                 <div className="d-flex justify-content-between align-items-start">
//                                     <div>
//                                         <p className="text-muted small fw-bold text-uppercase mb-1">{stat.title}</p>
//                                         <h2 className="fw-bold mb-1">{stat.value}</h2>
//                                         <small className={`${stat.color} fw-bold`} style={{ fontSize: '0.8rem' }}>
//                                             <i className="bi bi-graph-up-arrow me-1"></i> {stat.change}
//                                         </small>
//                                     </div>
//                                     <div className={`p-3 rounded-circle bg-light ${stat.color}`}>
//                                         <i className={`bi ${stat.icon} fs-4`}></i>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {/* --- 2. CHARTS SECTION (Visual Only) --- */}
//             <div className="row g-4 mb-5">
//                 {/* Line Chart Area */}
//                 <div className="col-md-8">
//                     <div className="card border-0 shadow-sm p-4" style={{ borderRadius: '12px', minHeight: '350px' }}>
//                         <h5 className="fw-bold mb-4">Total Hospital Appointments (Last 30 Days)</h5>
//                         {/* CSS Visualization of a chart line */}
//                         <div className="d-flex align-items-end justify-content-between h-100 px-2 pb-3" style={{ borderBottom: '1px solid #eee', height: '200px' }}>
//                             {[40, 60, 45, 70, 65, 80, 75, 90, 85, 95].map((h, i) => (
//                                 <div key={i} className="bg-primary opacity-75 rounded-top" style={{ width: '6%', height: `${h}%` }}></div>
//                             ))}
//                         </div>
//                         <div className="d-flex justify-content-between text-muted small mt-2">
//                             <span>Nov 10</span><span>Nov 15</span><span>Nov 20</span><span>Nov 25</span><span>Dec 1</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Pie Chart Area */}
//                 <div className="col-md-4">
//                     <div className="card border-0 shadow-sm p-4" style={{ borderRadius: '12px', minHeight: '350px' }}>
//                         <h5 className="fw-bold mb-4">Specialists Breakdown</h5>
//                         <div className="d-flex justify-content-center align-items-center h-100">
//                             {/* Simple CSS Circle to mimic Pie Chart */}
//                             <div className="rounded-circle"
//                                 style={{
//                                     width: '180px', height: '180px',
//                                     background: 'conic-gradient(#0d6efd 0% 35%, #198754 35% 60%, #ffc107 60% 80%, #dc3545 80% 100%)'
//                                 }}>
//                             </div>
//                         </div>
//                         <div className="d-flex justify-content-center gap-3 mt-3 small">
//                             <span className="text-primary"><i className="bi bi-circle-fill"></i> Cardio</span>
//                             <span className="text-success"><i className="bi bi-circle-fill"></i> Peds</span>
//                             <span className="text-warning"><i className="bi bi-circle-fill"></i> Ortho</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* --- 3. AFFILIATED DOCTORS TABLE --- */}
//             <div className="card border-0 shadow-sm mb-5" style={{ borderRadius: '12px' }}>
//                 <div className="card-header bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
//                     <h5 className="fw-bold mb-0">Affiliated Doctors Registry</h5>
//                     <input type="text" className="form-control w-25 shadow-sm" placeholder="Filter by name..." />
//                 </div>
//                 <div className="table-responsive">
//                     <table className="table table-hover align-middle mb-0">
//                         <thead className="bg-light text-muted small text-uppercase">
//                             <tr>
//                                 <th className="px-4 py-3">Doctor Name</th>
//                                 <th>Specialty</th>
//                                 <th>Status</th>
//                                 <th>Today's Bookings</th>
//                                 <th className="text-end px-4">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {doctorsList.map((doc, i) => (
//                                 <tr key={i}>
//                                     <td className="px-4 py-3 fw-bold">{doc.name}</td>
//                                     <td className="text-muted">{doc.specialty}</td>
//                                     <td>
//                                         <span className={`badge ${doc.status === 'Active' ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'} px-3 py-2 rounded-pill`}>
//                                             {doc.status}
//                                         </span>
//                                     </td>
//                                     <td className="fw-bold ps-4">{doc.bookings}</td>
//                                     <td className="text-end px-4">
//                                         <button className="btn btn-sm btn-light"><i className="bi bi-three-dots-vertical"></i></button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//             {/* SCANNER MODAL COMPONENT */}
//             <ScannerModal
//                 show={showScanner}
//                 onClose={() => setShowScanner(false)}
//             />
//         </div>
//     );
// };

// export default HospitalDashboard;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScannerModal from '../components/ScannerModal';
import axios from 'axios';

const HospitalDashboard = () => {
    const navigate = useNavigate();
    
    // --- STATE ---
    const [hospitalData, setHospitalData] = useState(null);
    const [showScanner, setShowScanner] = useState(false);
    
    // Dynamic Data States
    const [stats, setStats] = useState({
        totalDoctors: 0,
        todaysAppointments: 0,
        activePatients: 0,
        avgWaitTime: "--"
    });
    const [doctorsList, setDoctorsList] = useState([]);
    const [specialtyData, setSpecialtyData] = useState([]);
    const [loading, setLoading] = useState(true);

    // --- FETCH DATA ---
    useEffect(() => {
        // 1. Auth Check
        const userStr = localStorage.getItem('DDoctorUser');
        if (!userStr) {
            navigate('/');
            return;
        }
        
        const user = JSON.parse(userStr);
        if (user.role !== 'hospital') {
            alert("Access Denied. Hospital Account Required.");
            navigate('/');
            return;
        }

        setHospitalData(user);

        // 2. Fetch Dashboard Data from Backend
        const fetchStats = async () => {
            try {
                // Use the logged-in hospital's city, or default to Islamabad if missing
                const city = user.location || user.city || "Islamabad"; 
                
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals/stats?city=${city}`);
                
                if (res.data.success) {
                    setStats(res.data.stats);
                    setDoctorsList(res.data.doctorsList);
                    setSpecialtyData(res.data.specialtyData);
                }
            } catch (error) {
                console.error("Error fetching dashboard stats:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();

    }, [navigate]);

    return (
        <div className="container-fluid bg-light min-vh-100 p-4">

            {/* --- HEADER --- */}
            <div className="d-flex justify-content-between align-items-center mb-5">
                <div>
                    <h2 className="fw-bold text-dark mb-1">
                        {hospitalData?.name || "Hospital"} Network
                    </h2>
                    <p className="text-muted mb-0">
                        {hospitalData?.city || "Islamabad"} • Administration Portal
                    </p>
                </div>

                {/* SCANNER BUTTON */}
                <button
                    className="btn btn-primary btn-lg fw-bold shadow-sm d-flex align-items-center gap-2"
                    style={{ backgroundColor: '#0d6efd', borderRadius: '8px' }}
                    onClick={() => setShowScanner(true)}
                >
                    <i className="bi bi-qr-code-scan"></i> Scan Patient Card
                </button>
            </div>

            {/* --- 1. DYNAMIC STATS CARDS --- */}
            <div className="row g-4 mb-5">
                {/* Total Doctors */}
                <div className="col-md-3">
                    <div className="card border-0 shadow-sm h-100 p-4">
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="text-muted small fw-bold text-uppercase mb-1">Total Doctors</p>
                                <h2 className="fw-bold mb-0">{loading ? "..." : stats.totalDoctors}</h2>
                                <small className="text-success fw-bold" style={{ fontSize: '0.8rem' }}>
                                    <i className="bi bi-graph-up-arrow me-1"></i> Live Data
                                </small>
                            </div>
                            <div className="p-3 rounded-circle bg-light text-success">
                                <i className="bi bi-people-fill fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Today's Appointments */}
                <div className="col-md-3">
                    <div className="card border-0 shadow-sm h-100 p-4">
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="text-muted small fw-bold text-uppercase mb-1">Today's Appointments</p>
                                <h2 className="fw-bold mb-0">{loading ? "..." : stats.todaysAppointments}</h2>
                                <small className="text-primary fw-bold" style={{ fontSize: '0.8rem' }}>
                                    Scheduled
                                </small>
                            </div>
                            <div className="p-3 rounded-circle bg-light text-primary">
                                <i className="bi bi-calendar-check fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Active Patients */}
                <div className="col-md-3">
                    <div className="card border-0 shadow-sm h-100 p-4">
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="text-muted small fw-bold text-uppercase mb-1">Total Patients</p>
                                <h2 className="fw-bold mb-0">{loading ? "..." : stats.activePatients}</h2>
                                <small className="text-info fw-bold" style={{ fontSize: '0.8rem' }}>
                                    Registered Users
                                </small>
                            </div>
                            <div className="p-3 rounded-circle bg-light text-info">
                                <i className="bi bi-person-heart fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Avg Wait Time */}
                <div className="col-md-3">
                    <div className="card border-0 shadow-sm h-100 p-4">
                        <div className="d-flex justify-content-between">
                            <div>
                                <p className="text-muted small fw-bold text-uppercase mb-1">Avg. Wait Time</p>
                                <h2 className="fw-bold mb-0">{stats.avgWaitTime}</h2>
                                <small className="text-warning fw-bold" style={{ fontSize: '0.8rem' }}>
                                    Estimated
                                </small>
                            </div>
                            <div className="p-3 rounded-circle bg-light text-warning">
                                <i className="bi bi-stopwatch fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- 2. SPECIALISTS BREAKDOWN & CHARTS --- */}
            <div className="row g-4 mb-5">
                {/* Left Side: Placeholder Chart */}
                <div className="col-md-8">
                    <div className="card border-0 shadow-sm p-4 h-100">
                        <h5 className="fw-bold mb-4">Patient Traffic Overview</h5>
                        <div className="d-flex align-items-end justify-content-between h-100 px-2 pb-3" style={{ borderBottom: '1px solid #eee', height: '200px' }}>
                             {/* Simple CSS Bar Chart Visualization */}
                            {[40, 60, 45, 70, 65, 80, 75, 90, 85, 95].map((h, i) => (
                                <div key={i} className="bg-primary opacity-75 rounded-top" style={{ width: '6%', height: `${h}%` }}></div>
                            ))}
                        </div>
                        <div className="d-flex justify-content-between text-muted small mt-2">
                            <span>Week 1</span><span>Week 2</span><span>Week 3</span><span>Week 4</span>
                        </div>
                    </div>
                </div>

                {/* Right Side: Dynamic Specialty List */}
                <div className="col-md-4">
                    <div className="card border-0 shadow-sm p-4 h-100">
                        <h5 className="fw-bold mb-4">Specialists in Your City</h5>
                        
                        {loading ? (
                             <p className="text-center mt-5">Loading...</p>
                        ) : specialtyData.length === 0 ? (
                            <div className="text-center my-5 text-muted">
                                <i className="bi bi-person-x fs-1 d-block mb-2"></i>
                                <p>No doctors found in this city.</p>
                            </div>
                        ) : (
                            <ul className="list-group list-group-flush">
                                {specialtyData.map((spec, index) => (
                                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center border-0 px-0">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-light rounded-circle p-2 me-3 text-primary">
                                                <i className="bi bi-person-badge"></i>
                                            </div>
                                            <span className="fw-bold text-dark">{spec._id}</span>
                                        </div>
                                        <span className="badge bg-primary rounded-pill">{spec.count} Doctors</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            {/* --- 3. DYNAMIC DOCTORS TABLE --- */}
            <div className="card border-0 shadow-sm mb-5" style={{ borderRadius: '12px' }}>
                <div className="card-header bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold mb-0">Affiliated Doctors Registry</h5>
                </div>
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                        <thead className="bg-light text-muted small text-uppercase">
                            <tr>
                                <th className="px-4 py-3">Doctor Name</th>
                                <th>Specialty</th>
                                <th>City</th>
                                <th>Fee</th>
                                <th className="text-end px-4">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="text-center py-5">Loading Registry...</td></tr>
                            ) : doctorsList.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-5 text-muted">
                                        No doctors registered in {hospitalData?.city || "your area"} yet.
                                    </td>
                                </tr>
                            ) : (
                                doctorsList.map((doc, i) => (
                                    <tr key={i}>
                                        <td className="px-4 py-3 fw-bold">
                                            <div className="d-flex align-items-center">
                                                <div className="bg-light rounded-circle text-center d-flex justify-content-center align-items-center me-3" style={{width: '35px', height: '35px'}}>
                                                    <i className="bi bi-person-fill text-secondary"></i>
                                                </div>
                                                {doc.name}
                                            </div>
                                        </td>
                                        <td className="text-muted">{doc.specialty}</td>
                                        <td>{doc.city}</td>
                                        <td>PKR {doc.fee}</td>
                                        <td className="text-end px-4">
                                            <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill">
                                                Active
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* SCANNER MODAL */}
            <ScannerModal
                show={showScanner}
                onClose={() => setShowScanner(false)}
            />
        </div>
    );
};

export default HospitalDashboard;